import {Layout, Statistic} from "antd"
import {useDispatch, useSelector} from "react-redux"
import {StateType} from "../store/store"
import {useEffect, useMemo, useRef} from "react"
import {getStatistics} from "../store/appReducer"

const {Footer: AntFooter} = Layout

export const Footer = () => {
    const dispatch = useDispatch()
    const statistics = useSelector((state: StateType) => state.appReducer.statistics)
    const controller = useMemo(() => new AbortController(), [])
    const timer = useRef<any>()

    useEffect(() => {
        dispatch(getStatistics({controller}))
        timer.current = setInterval(() => dispatch(getStatistics({controller, withoutLoadingIndicator: true})), 30000)

        return () => {
            clearInterval(timer.current)
            controller.abort()
        }
    }, [dispatch, controller])

    return (
        <AntFooter>
            <div className="footer">
                <Statistic title="Пользователей" value={statistics?.totalUsers} valueStyle={{color: "#8c8c8c", fontSize: 14, textAlign: 'center'}} loading={!statistics}/>
                <Statistic title="Объектов" value={statistics?.totalObjects} valueStyle={{color: "#8c8c8c", fontSize: 14, textAlign: 'center'}} loading={!statistics}/>
                <Statistic title="Оборудование" value={statistics?.totalPSLeakDevices} valueStyle={{color: "#8c8c8c", fontSize: 14, textAlign: 'center'}} loading={!statistics}/>
                <Statistic title="Не в сети" value={statistics?.offlinePSLeakDevices} valueStyle={{color: "#8c8c8c", fontSize: 14, textAlign: 'center'}} loading={!statistics}/>
                <Statistic title="Требуют внимания" value={statistics?.problemPSLeakDevices} valueStyle={{color: "#8c8c8c", fontSize: 14, textAlign: 'center'}} loading={!statistics}/>
                <Statistic title="Не решенные" value={statistics?.totalLogs} valueStyle={{color: "#8c8c8c", fontSize: 14, textAlign: 'center'}} loading={!statistics}/>
            </div>
        </AntFooter>
    )
}